module.exports = __webpack_public_path__ + "img/9788984315679.5a1cf6c0.jpg";